import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";

const SwitchConflict = (props) => {
  const [conflictExternal, setConflictExternal] = useState("manual");

  useEffect(() => {
    setConflictExternal(props.externalParentToChild);
  }, [props]);

  const handleChangeConflictExternal = (event) => {
    const newValue = event.target.value;
    setConflictExternal(newValue);
    props.conflictExternalParentCallback(newValue);
  };

  return (
    <Box
      sx={{
        border: 1,
        borderRadius: 2,
        borderColor: "primary.main",
        pl: 2,
        pr: 2,
        pb: 2,
      }}
    >
      <Box>
        <FormControl id="formConflictExternal" sx={{ mt: 2, ml: 1 }}>
          <FormLabel id="radio-conflictExternal-group-label">
            É possível cadastrar uma ou mais reservas para uma atividade. No
            entanto, em determinadas datas, o local escolhido pode já estar
            ocupado por reservas de outras atividades. Para lidar com esses
            conflitos, o sistema oferece diferentes modos de gerenciamento,
            descritos a seguir:
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="radio-conflictExternal-group"
            name="controlled-radio-conflictExternal-group"
            value={conflictExternal}
            onChange={handleChangeConflictExternal}
          >
            <List>
              <ListItem disablePadding>
                <FormControlLabel
                  value="manual"
                  control={<Radio />}
                  label="Manual - O usuário decide, caso a caso, se deseja ignorar ou substituir cada reserva que estiver em conflito."
                  sx={{ mt: 1, mb: 1 }}
                />
              </ListItem>
              <ListItem disablePadding>
                <FormControlLabel
                  value="ignore"
                  control={<Radio />}
                  label="Automático (Ignorar) - Apenas as reservas sem conflito são cadastradas."
                  sx={{ mb: 1 }}
                />{" "}
              </ListItem>
              <ListItem disablePadding>
                <FormControlLabel
                  value="abort"
                  control={<Radio />}
                  label="Automático (Cancelar) - Nenhuma das reservas é cadastrada se houver algum conflito."
                  sx={{ mb: 1 }}
                />{" "}
              </ListItem>
              <ListItem disablePadding>
                <FormControlLabel
                  value="overwrite"
                  control={<Radio />}
                  label="Automático (Substituir) - Todas as reservas são cadastradas, substituindo os conflitos."
                />
              </ListItem>
            </List>
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
};

SwitchConflict.defaultProps = {
  externalParentToChild: "manual",
  conflictExternalParentCallback: () => {},
};

SwitchConflict.propTypes = {
  externalParentToChild: PropTypes.string,
  conflictExternalParentCallback: PropTypes.func,
};

export default SwitchConflict;
